module.exports = __webpack_public_path__ + "static/media/cv.326414f0.pdf";